module.exports = __webpack_public_path__ + "img/algeria.4450a753.svg";